import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import generateSignature from './useGenerateSignature.request';
import { SignatureResponse, SignatureResponseError } from './useGenerateSignature.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import { collectiveTracking } from 'modules/common/components/AnalyticsTracking/utils';

const useGenerateSignature = () => {
    return useMutation<SignatureResponse, AxiosError<SignatureResponseError>, { id: string }>({
        mutationFn: ({ id }) => generateSignature(id),
        retry: 3,
        onError: (error) => {
            sendDatadogRumError('Decagon signature generation failed', error);
            collectiveTracking.track({
                name: 'Help Agent Signature Generation Failed',
                properties: {
                    category: 'help_agent',
                    status: error.response?.status,
                },
            });
        },
    });
};

export default useGenerateSignature;
